import { BlogDetailedPage } from '@/pages/blog-detailed';
import { rootSearchSchema } from '@/schemas/search-params';
import { createFileRoute, retainSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@/lib/zod-adapter';
import { processSQSearch } from '@/utils/loader';

export const Route = createFileRoute('/_layout/blog/$slug')({
  validateSearch: zodValidator(rootSearchSchema),
  search: {
    middlewares: [retainSearchParams(['conversation_id', 'agent-token'])],
  },
  beforeLoad({ search }) {
    const parsedSearch = rootSearchSchema.safeParse(search);
    if (!parsedSearch.success) {
      //TODO: Log to Sentry
      console.error('Invalid search parameters: ', parsedSearch.error);
    }
  },
  loader: ({ context }) => {
    const { queryClient } = context;
    processSQSearch(queryClient);
  },
  component: () => <BlogDetailedPage />,
});
